import * as s from "./AdminModalStyled";
import SmallPopupDefaultTemplate from "components/templates/modal/small/SmallPopupDefaultTemplate";
import BigButton from "components/atoms/buttons/BigButton";
import { useCallback } from "react";
import { ReactComponent as UserSVG } from "assets/icons/sidenav/users.svg";
import { useAppSelector } from "redux/hooks";
import useStatusMutation from "hook/useStatusMutation";
import moment from "moment";
import { postAccountDecide } from "api/accountAPI";
import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import useApiError from "hook/useApiError";

interface Props {
  onModal: () => void;
}

export default function KeepAccountModal(props: Props) {
  const selectedAccount: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );
  const { intlString, lang, handleErrorNotify, notifySuccess, notifyError } =
    useApiError();
  const failIntlMsg = (isDecide: number) => {
    return isDecide === 1
      ? intlString(lang.validateMsg.account.removeAccount.fail)
      : intlString(lang.validateMsg.account.keepAccount.fail);
  };

  const mutationKeepAccount = useStatusMutation(postAccountDecide, {
    onSuccess: (res) => {
      if (res.error || res.errorString) {
        notifyError(failIntlMsg(res.result?.isDecide));
      } else {
        notifySuccess(
          res.result?.isDecide === 1
            ? intlString(lang.validateMsg.account.removeAccount.success)
            : intlString(lang.validateMsg.account.keepAccount.success)
        );
        props.onModal();
      }
    },
    onError: (err) => {
      handleErrorNotify(err, failIntlMsg(err.response?.data?.result?.isDecide));
    },
  });

  const onClickAccount = useCallback(
    async (type: "remove" | "keep") => {
      mutationKeepAccount.mutate({
        accountId: selectedAccount.accountId,
        isDecide: type === "remove" ? 1 : 2,
      });
    },
    [selectedAccount.accountId]
  );

  const ButtonArea = () => {
    return (
      <s.AccessButtonWrapper>
        <BigButton
          label="Decide Later"
          buttonType="cancel"
          onClickBtn={() => {
            props.onModal();
          }}
          data-testid="users-admin-admin-button-modal"
        />

        <div>
          <BigButton
            label="Remove"
            buttonType="warning"
            disabled={!mutationKeepAccount.idle}
            onClickBtn={() => onClickAccount("remove")}
            data-testid="users-admin-admin-button-click-account"
          />

          <BigButton
            label="Keep"
            disabled={!mutationKeepAccount.idle}
            onClickBtn={() => onClickAccount("keep")}
            data-testid="users-admin-admin-button-click-account-2"
          />
        </div>
      </s.AccessButtonWrapper>
    );
  };

  return (
    <SmallPopupDefaultTemplate
      button={<ButtonArea />}
      onModal={() => {
        props.onModal();
      }}
    >
      <s.AccessNotifyWrapper>
        <s.AccessNotifyTitle>
          <UserSVG /> Installer Account
        </s.AccessNotifyTitle>
        <s.AccessNotifyContent>
          This organization has recently been transferred to you, would you like
          to keep the previous administrator on your user list?
          <br />
          If no action is taken, this user will be deleted from your
          organization on{" "}
          {moment(selectedAccount.createdAt)
            .add(30, "days")
            .format("MMM DD YYYY")}
          .<br />
        </s.AccessNotifyContent>
        <s.AccessNotifyContent>
          <label>Installer</label>
          <b>{selectedAccount.creatorName}</b>
          <br />
          <span>{selectedAccount.creatorEmail}</span>
        </s.AccessNotifyContent>
      </s.AccessNotifyWrapper>
    </SmallPopupDefaultTemplate>
  );
}
